import { ChevronRightSolid, IcoEye, IcoEyeSlash } from '@icons';
import React, { Fragment, ReactNode, useState } from 'react';
import { Button } from 'react-bootstrap';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';

type PanelProps = {
	key: string;
	content: ReactNode;
	title: string;
	defaultIsVisible?: boolean;
};

const SplitPanel = ({ panels }: { panels: PanelProps[] }) => {
	const [panelsWithVisibility, setPanelsWithVisibility] = useState(
		panels.map((panel) => ({
			...panel,
			isVisible: panel.defaultIsVisible ?? true,
		})),
	);

	const switchVisibilityByKey = (key: string) => {
		setPanelsWithVisibility((currentPanelsWithVisibility) =>
			currentPanelsWithVisibility.map((panel) => (panel.key === key ? { ...panel, isVisible: !panel.isVisible } : panel)),
		);
	};

	return (
		<div
			style={{
				height: '100%',
				overflow: 'hidden',
				display: 'grid',
				gridTemplateRows: 'auto 1fr',
			}}
		>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					gap: '32px',
					padding: '24px',
					backgroundColor: '#DEE4F1',
					borderRadius: '8px 8px 0 0',
				}}
			>
				{panelsWithVisibility.map((panel) => {
					return (
						<Button
							key={panel.title}
							className={`btn ${panel.isVisible ? 'custom-primary-button' : 'custom-outline-button'}`}
							// variant={panel.isVisible ? 'secondary' : 'light'}
							style={{
								width: '200px',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								gap: '0.5rem',
								textTransform: 'none',
								fontWeight: 500,
							}}
							onClick={() => {
								switchVisibilityByKey(panel.key);
							}}
						>
							{panel.title}

							{panel.isVisible ? (
								<IcoEye style={{ fill: '#fff' }} />
							) : (
								<IcoEyeSlash
									style={{
										// fill: '#1C2743'
										fill: 'var(--np-primary-color)',
									}}
								/>
							)}
						</Button>
					);
				})}
			</div>
			<div
				style={{
					borderRadius: '0 0 8px 8px',
					overflow: 'hidden',
					backgroundColor: '#fff',
				}}
			>
				<PanelGroup direction="horizontal">
					{panelsWithVisibility.map((panel) => {
						// if (!panel.isVisible) return null;
						const visiblePanels = panelsWithVisibility.filter((panelWithVisibility) => panelWithVisibility.isVisible);
						const visibleIndex = visiblePanels.findIndex((visiblePanel) => visiblePanel.key === panel.key);
						const isLastVisible = visibleIndex === visiblePanels.length - 1;

						return (
							<Fragment key={panel.title}>
								<Panel
									style={{
										padding: '16px 24px',
										overflowY: 'auto',
										display: panel.isVisible ? 'block' : 'none',
										// minWidth: '250px'
									}}
								>
									{panel.content}
								</Panel>
								<PanelResizeHandle
									style={{
										position: 'relative',
										alignItems: 'center',
										display: panel.isVisible && !isLastVisible ? 'flex' : 'none',
									}}
								>
									<div
										style={{
											position: 'absolute',
											top: 0,
											left: '50%',
											height: '100%',
											borderWidth: '1px',
											borderStyle: 'solid',
											borderColor: '#2A3A64',
										}}
									/>
									<div
										style={{
											backgroundColor: '#2A3A64',
											color: 'white',
											height: '24px',
											borderRadius: '16px',
											display: 'flex',
											alignItems: 'center',
										}}
									>
										<ChevronRightSolid style={{ width: '24px', height: '24px', transform: 'scale(-1, 1)' }} />
										<ChevronRightSolid style={{ width: '24px', height: '24px' }} />
									</div>
								</PanelResizeHandle>
							</Fragment>
						);
					})}
				</PanelGroup>
			</div>
		</div>
	);
};

export default SplitPanel;
